module.exports = __webpack_public_path__ + "img/logbac.70b39235.jpg";